/**
 * Extrait l'id numérique employé depuis une route (`693`, `emp-693`, …).
 */
export function parseEmployeeRouteId(raw: string | null | undefined): number {
  if (!raw) return Number.NaN;
  const trimmed = raw.trim();
  const prefixed = trimmed.match(/^emp-(\d+)$/i);
  if (prefixed) {
    return Number.parseInt(prefixed[1], 10);
  }
  return Number.parseInt(trimmed, 10);
}
